import { BehaviorSubject } from 'rxjs';

import ValidationException from '../exceptions/ValidationException';
import AmbraNamespace from '../models/AmbraNamespace';

export default class CreateWorkSpaceBloc {
  clinicCode$ = new BehaviorSubject('');
  isSubmitting$ = new BehaviorSubject(false);
  isRequestingCode$ = new BehaviorSubject(false);
  ambraNamespaces$ = new BehaviorSubject([]);

  constructor({ workspaceRepository, errorRepository, ambraNamespaceRepository }) {
    this.workspaceRepository = workspaceRepository;
    this.errorRepository = errorRepository;
    this.ambraNamespaceRepository = ambraNamespaceRepository;
  }

  updateClinicCode(code) {
    this.clinicCode$.next(code);
  }

  async createWorkspace(data) {
    const image = data.logoUrl;
    if (image.size / 1024 / 1024 > 3) {
      throw new ValidationException([
        {
          constraints: {
            logoUrl: 'Logo image can not be larger than 3MB',
          },
          property: 'logoUrl',
        },
      ]);
    }

    try {
      this.isSubmitting$.next(true);
      await this.workspaceRepository.createWorkspace(data);
    } catch (error) {
      if (!this.checkIsClinicCodeError(error)) throw error;
      await this.reSubmitData(data);
    } finally {
      this.isSubmitting$.next(false);
    }
  }

  async requestClinicCode(name, forceRequest = false) {
    const proceedRequest = this.checkIfContiuneRequestCode(name);
    if (!proceedRequest && !forceRequest) return false;

    try {
      this.isRequestingCode$.next(true);
      const { code } = await this.workspaceRepository.requestClinicCode(name);
      this.updateClinicCode(code);
      return code;
    } catch (error) {
      this.updateClinicCode('');
      throw error;
    } finally {
      this.isRequestingCode$.next(false);
    }
  }

  async getAmbraNamespaces() {
    const results = await this.ambraNamespaceRepository.getAmbraNamespace();
    this.ambraNamespaces$.next(results.map((result) => new AmbraNamespace({ label: result.name, value: result.id })));
  }

  checkIfContiuneRequestCode(name) {
    const clinicCode = this.clinicCode$.getValue();
    const clinicCodeSub = typeof clinicCode === 'string' && clinicCode.length >= 3 ? clinicCode.substring(0, 3).toUpperCase() : false;
    if (!clinicCodeSub) return true;

    const nameSub = typeof name === 'string' && name.length >= 3 ? name.substring(0, 3).toUpperCase() : false;
    if (!nameSub) return false;

    return clinicCodeSub !== nameSub;
  }

  checkIsClinicCodeError(error) {
    if (error?.errors?.clinicCode) {
      return true;
    }

    return false;
  }

  async reSubmitData(data) {
    const newCode = await this.requestClinicCode(data.name, true);

    await this.createWorkspace({ ...data, clinicCode: newCode });
  }
}
